import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { doctorCreate, doctorListFetch } from '../../../actions/doctorActions';
import { tooltipShow } from '../../../actions/tooltipActions';

// components
import CreateDoctorTooltip from './_CreateDoctorTooltip';
import IndexRow from './_IndexRow';
import { Panel, PanelBody, PanelHeader } from '../../shared/_panel';

// constants
const TOOLTIP_ID = 'createDoctorTooltip';

class Index extends React.Component {
  static propTypes = {
    doctor: PropTypes.instanceOf(Immutable.Map)
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map() };
  }

  componentDidMount() {
    this.props.dispatch(doctorListFetch());
  }

  render() {
    return (
      <Panel className='manager__doctor-index__panel'>
        <PanelHeader>
          <div className='manager__doctor-index__panel__header__left'>
            Doctors
          </div>
          <div className='manager__doctor-index__panel__header__right'>
            <CreateDoctorTooltip />
          </div>
        </PanelHeader>
        <PanelBody>
          <p className='manager__doctor-index__description'>
            All information provided is visible to reps. Leave any fields you do
            not want visible blank.
          </p>
          <div className='manager__doctor-index__table'>
            <div className='manager__doctor-index__table__header'>
              <div className='manager__doctor-index__table__doctor-name'>
                Doctor Name
              </div>
              <div className='manager__doctor-index__table__doctor-days-in'>
                Days In
              </div>
              <div className='manager__doctor-index__table__doctor-email'>
                Email
              </div>
            </div>
            <div className='manager__doctor-index__table__body'>
              { this._renderList() }
            </div>
          </div>
        </PanelBody>
      </Panel>
    );
  }

  // private

  _handleAddDoctor                = this._handleAddDoctor.bind(this);
  _handleShowCreateDoctorTooltip  = this._handleShowCreateDoctorTooltip.bind(this);

  _handleAddDoctor(attributes) {
    const { dispatch } = this.props;

    dispatch(doctorCreate(attributes));
  }

  _handleShowCreateDoctorTooltip() {
    const { dispatch } = this.props;

    dispatch(tooltipShow({ id: TOOLTIP_ID }));
  }

  _renderList() {
    const { doctor } = this.props;

    const data    = doctor.get('data') || Immutable.Map();
    const result  = doctor.get('result') || Immutable.List();
    const loading = doctor.get('loading');

    let components = [];

    if (loading &&  result.size === 0) {
      components = (
        <p className='manager__doctor-index__table__text'>
          <i className='fa fa-spin fa-circle-o-notch' />
        </p>
      );
    } else if (result.size === 0) {
      components = (
        <p className='manager__doctor-index__table__text'>
          There are currently no doctors
        </p>
      );
    } else {
      result.forEach((id) => {
        if (data.get(id)) {
          components.push(
            <IndexRow doctor={ data.get(id) } key={ id } />
          );
        }
      });
    }
    return components;
  }
}

const mapStateToProps = (state) => {
  return {
    doctor: state.get('doctor')
  };
};

export default connect(mapStateToProps)(Index);



// WEBPACK FOOTER //
// ./app/components/managers/doctors/Index.jsx